import { useEffect, useState } from "react";

const FIRST_MESSAGE_DELAY_MS = 1500;
const MESSAGE_INTERVAL_MS = 2000;

export const usePendingMessage = (
  messages: readonly string[],
): string | undefined => {
  const [index, setIndex] = useState(-1);

  useEffect(() => {
    if (messages.length === 0) return;

    let interval: ReturnType<typeof setInterval> | undefined;
    const delay = setTimeout(() => {
      setIndex(0);
      interval = setInterval(() => {
        setIndex((current) => (current + 1) % messages.length);
      }, MESSAGE_INTERVAL_MS);
    }, FIRST_MESSAGE_DELAY_MS);

    return () => {
      clearTimeout(delay);
      if (interval) clearInterval(interval);
    };
  }, [messages]);

  return index < 0 ? undefined : messages[index];
};
